import React, { useEffect, useState } from 'react';
import "./ProductInfo.css";

function ProductInfo () {
    let [ mobile, setMobile ] = useState( false );

    useEffect( () => {
        window.scrollTo( 0, 0 );
        if ( document.getElementById( "root" ).clientWidth < 600 ) {
            setMobile( true );
        }
    }, [] );

    return (
        <div className='product-info-container'>
            <div className='products-banner'>
                {!mobile && <img src={require( "../../images/products/info/banner.avif" )} alt="product-banner" height={"100%"} width={"100%"} />}
                {mobile && <img src={require( "../../images/products/info/banner-mobile.avif" )} alt="product-banner" height={"100%"} width={"100%"} />}
                <div className='products-banner-content'>
                    <span>Our Products</span>
                    <span>Precision-engineered fasteners for secure, reliable, and high-performance applications in aerospace and beyond.</span>
                </div>
            </div>
            <div className='product-info'>
                <img src={require( "../../images/products/info/image1.avif" )} alt="product-info-1" height={"100%"} width={"100%"} />
                <div className='product-info-text'>
                    <div className='product-info-head'>Product Name</div>
                    <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc consectetur consectetur ligula, ac posuere felis gravida vitae. Nulla rutrum, purus eget venenatis efficitur, </div>
                    <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc consectetur consectetur ligula, ac posuere </div>
                </div>
            </div>
            <div className='product-info'>
                <div className='product-info-text'>
                    <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc consectetur consectetur ligula, ac posuere felis gravida vitae. Nulla rutrum, purus eget venenatis efficitur, </div>
                    <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc consectetur consectetur ligula, ac posuere felis gravida vitae. Nulla rutrum, purus eget venenatis efficitur, </div>
                </div>
                <img src={require( "../../images/products/info/image2.avif" )} alt="product-info-1" height={"100%"} width={"100%"} />
            </div>
            <div className='product-info'>
                <img src={require( "../../images/products/info/image3.avif" )} alt="product-info-1" height={"100%"} width={"100%"} />
                <div className='product-info-text'>
                    <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc consectetur consectetur ligula, ac posuere felis gravida vitae. Nulla rutrum, purus eget venenatis efficitur, </div>
                    <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc consectetur consectetur ligula, ac posuere felis gravida vitae. Nulla rutrum, purus eget venenatis efficitur, </div>
                </div>
            </div>
        </div>
    )
}

export default ProductInfo
